import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  StandaloneSearchBox,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete";
import { Card, Typography, MuiThemeProvider } from "@material-ui/core";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import Button from "@mui/material/Button";

import { useLocation } from "react-router-dom";

// import  from '@mui/material/Button';

import { useNavigate } from "react-router-dom";
import axios from "axios";

// import {  Grid } from '@material-ui/core';

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";

import { test_ip } from "../services/constants";

import { toast } from "react-toastify";

import { setError } from "../services/actions";
import { useDispatch } from "react-redux";

import { Container, Grid } from "@material-ui/core";

import { check_error_code } from "../services/error_string";
import Loading from "../components/Loading";
function Locations({ props }) {
  var total_distance;
  const [flag, setFlag] = useState(false);
  const [current_latitude, setLatitude] = useState(null);
  const [current_longitude, setLongitude] = useState(null);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null,
  });
  const diapach = useDispatch();
  const location = useLocation();
  const nav = useNavigate();
  var user = JSON.parse(localStorage.getItem("user"));
  var store_id = localStorage.getItem("store_id");
  var req_data = location.state.req_data;
  const requestLocationPermission = () => {
    const fetchCurrentLocation = JSON.stringify({
      functionName: "fetchCurrentLocation",
      params: {
        callbackName: "handleLocationCallback",
      }, // Registering permission callback
    });

    if (window.dashenbanksuperapp) {
      alert("Requesting location permissions...");
      console.log("Requesting location permissions...");
      window.dashenbanksuperapp.send(fetchCurrentLocation);
    } else {
      alert("Dashen Bank SuperApp is not available!!!!!!!!!!!!!");
      console.error("Dashen Bank SuperApp is not available!");
    }
  };
  const handleLocationCallback = (result) => {
    // alert(`latitude ${result.latitude} , longtiude ${result.longitude}`);
    console.log("Permission callback result:", result);
    if (result) {
      setLatitude(result.latitude);
      setLongitude(result.longitude);
    } else {
      alert("Location permission denied!");
      const UserLocation = JSON.parse(localStorage.getItem("userLocation"));
      setLatitude(UserLocation.latitude);
      setLongitude(UserLocation.longitude);
    }
  };
  useEffect(() => {
    window.handleLocationCallback = handleLocationCallback;
    requestLocationPermission();
  }, []);
  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const ll = await getLatLng(results[0]);
    // console.log(ll);
    // console.log(location.state);
    setAddress(value);
    setCoordinates(ll);
    setFlag(true);
  };
  const send = function () {
    // console.log(address);
    if (flag) {
      console.log("if");
      req_data.destination_address.name = address;
      req_data.destination_address.lat = coordinates.lat;
      req_data.destination_address.long = coordinates.lng;
    } else {
      console.log("else");
      req_data.destination_address.name = "Current Location";
      req_data.destination_address.lat = current_latitude;
      req_data.destination_address.long = current_longitude;
    }
    Add_Item_to_Cart(req_data);
  };
  const compute_price = () => {
    let final_price = 0;
    let items = req_data.items;
    items.forEach((item) => {
      var price = item.price;

      for (let j = 0; j < item.specifications.length; j++) {
        // price +=spec_items[i].list.price
        for (let i = 0; i < item.specifications[j].list.length; i++) {
          price += item.specifications[j].list[i].price;
          console.log("looping at ", i, j, price);
        }
      }
      final_price += item.price * item.quantity;
    });
    return final_price;
  };
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3; // Earth's radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c;
    return distance;
  };
  var Add_Item_to_Cart = function (data) {
    // call this only if store_count == 1
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/add_item_in_cart_new`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          // console.log(res.data);
          if (res.data.success == true) {
            var cart_id = res.data.cart_id; // you would get more data but this is the most important
            localStorage.setItem("cart_id", cart_id);
            const store_lat = req_data.store_location.lat;
            const store_lon = req_data.store_location.long;
            if (flag && coordinates.lat && coordinates.lng) {
              console.log("if its search away");
              total_distance = calculateDistance(
                coordinates.lat,
                coordinates.lng,
                store_lat,
                store_lon
              );
              console.log(total_distance);
            } else {
              if (current_latitude && current_longitude) {
                console.log("if its from dashen");
                total_distance = calculateDistance(
                  current_latitude,
                  current_longitude,
                  store_lat,
                  store_lon
                );
                console.log(total_distance);
              }
            }
            console.log("locatios from dashen");
            console.log(current_latitude);
            console.log(current_longitude);
            console.log("location from  search");
            console.log(coordinates.lat);
            console.log(coordinates.lng);
            console.log("store locations");
            console.log(store_lat);
            console.log(store_lon);

            console.log(total_distance);
            var another_req_object = {
              cart_id: cart_id,
              store_id: store_id,
              total_time: 120,
              total_distance: total_distance,
              order_type: 7,
              is_user_pick_up_order: false,
              total_item_count: req_data.items.length,
              is_user_drop_order: true,
              express_option: "normal",
              server_token: user.server_token,
            };
            console.log(another_req_object);
            Get_order_cart_invoice(another_req_object);
          } else {
            console.log("erororor", res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              var message = check_error_code(res.data.error_code);
              diapach(setError({ error: true, message: message }));
            }
            // if (res.data.error_code === 999)
          }
        } else {
          // do something
          diapach(setError({ error: true, message: "failed,please reload" }));
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
        console.log(err);
      });
  };
  var Get_order_cart_invoice = function (data) {
    // call this only if store_count == 1
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/get_order_cart_invoice`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          console.log("ooryeyeyeyyeye 2");
          if (res.data.success == true) {
            var order_payment = res.data.order_payment; // you would get more data but this is the most important
            var vehicles = res.data.vehicles; // get vehicle list
            console.log(vehicles);
            console.log(order_payment);
            localStorage.setItem(
              "order_payment",
              JSON.stringify(order_payment)
            );
            // setSuccess(`successfully on ${vehicles[0].vehicle_name}`)
            nav(`/payment/${order_payment.unique_id}`, {
              state: { order: order_payment, vehicles: vehicles },
            });

            // setCart([])
          } else {
            console.log("erorororor1", res.data.error_code);
            if (res.error_code === 999) {
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            }
            var message = check_error_code(res.data.error_code);

            diapach(setError({ error: true, message: message }));
          }
        } else {
          // do something
          diapach(setError({ error: true, message: "error occured" }));
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
        console.log(err);
      });
  };
  const handleFlag = () => {
    setFlag(!flag);
  };
  return (
    <div>
      <ThemeProvider theme={theme}>
        <div
          style={{
            backgroundColor: "white",
            marginTop: "5px",
            marginBottom: "5px",
            padding: "8px",
            fontSize: "0.8rem",
          }}
        >
          <h3 style={{ fontSize: "1.2rem" }}>Dear ,{user.first_name}</h3>
          <div style={{ fontSize: "0.7rem" }}>
            you are about to pay <b>{compute_price()}</b> birr{" "}
          </div>
        </div>
        <Container>
          <Grid container style={{ display: "flex", justifyContent: "center" }}>
            <Grid
              item
              key={122}
              xs={12}
              md={6}
              lg={3}
              style={{ paddingTop: "2px", padding: "0px" }}
            >
              {/* <Card style={{ margin: '0 auto', marginTop: '5px', display: 'flex', alignItems: 'center', flexDirection: 'column', padding: '5px' }}> */}
              <Card style={{ padding: "8px" }}>
                <h3 style={{ fontSize: "1.2rem" }}>Select Location</h3>
                <FormGroup
                  style={{
                    textAlign: "start",
                    width: "100%",
                    paddingLeft: "10px",
                  }}
                >
                  {/* <FormControlLabel color='neutral' control={<Checkbox checked={!flag} onChange={handleFlag} color='default' />} label="Current Location" /> */}
                  {/* <FormControlLabel color='neutral' control={<Checkbox checked={flag} onChange={handleFlag} color='default' />} label="Search away" /> */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="neutral"
                        size="small"
                        checked={!flag}
                        onChange={handleFlag}
                        style={{ fontSize: "0.8rem", padding: "5px" }}
                      />
                    }
                    label={
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Current Location
                      </Typography>
                    }
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        color="neutral"
                        size="small"
                        checked={flag}
                        onChange={handleFlag}
                        style={{ fontSize: "0.8rem", padding: "5px" }}
                      />
                    }
                    label={
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Search Away
                      </Typography>
                    }
                  />
                </FormGroup>
                {flag ? (
                  <div style={{ textAlign: "start", width: "100%" }}>
                    {" "}
                    <p>address: {address}</p>
                    <PlacesAutocomplete
                      value={address}
                      onChange={setAddress}
                      onSelect={handleSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div>
                          <input
                            {...getInputProps({
                              placeholder: "Search Places ...",
                              className: "location-search-input",
                            })}
                          />
                          <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map((suggestion, index) => {
                              const className = suggestion.active
                                ? "suggestion-item--active"
                                : "suggestion-item";
                              // inline style for demonstration purpose
                              const style = suggestion.active
                                ? {
                                    backgroundColor: "#fafafa",
                                    cursor: "pointer",
                                  }
                                : {
                                    backgroundColor: "#ffffff",
                                    cursor: "pointer",
                                  };
                              return (
                                <div
                                  key={suggestion.placeId || index} // Add a unique key here
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                  </div>
                ) : null}

                {/* isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        onUnmount={onUnmount}
      > */}
                {/* Child components, such as markers, info windows, etc. */}
                {/* <></>
      </GoogleMap>
  ) : <></> */}

                {/* <div>
        <div id="searchbox">
          <StandaloneSearchBox
            onLoad={onSBLoad}
            onPlacesChanged={onPlacesChanged}
            // bounds={window.google.maps.state.bounds}
          >
            <input
              type="text"
              placeholder="Customized your placeholder"
              style={{
                boxSizing: `border-box`,
                border: `1px solid transparent`,
                width: `240px`,
                height: `32px`,
                padding: `0 12px`,
                borderRadius: `3px`,
                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                fontSize: `14px`,
                outline: `none`,
                textOverflow: `ellipses`,
                position: "absolute",
                left: "50%",
                marginLeft: "-120px"
              }}
            />
          </StandaloneSearchBox>
        </div>
        <br />
        <div>
          <GoogleMap
            center={this.state.currentLocation}
            zoom={10}
            onLoad={map => onMapLoad(map)}
            mapContainerStyle={{ height: "400px", width: "800px" }}
          >
            {this.state.markers.map((mark, index) => (
              <Marker key={index} position={mark} />
            ))}
          </GoogleMap>
        </div>
      </div> */}
              </Card>
              <div
                style={{
                  marginTop: "8px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  size="small"
                  color="neutral"
                  style={{ borderRadius: "10px" }}
                  variant="contained"
                  onClick={() => {
                    send();
                  }}
                >
                  Proceed
                </Button>
              </div>

              <div></div>
            </Grid>
          </Grid>
        </Container>
      </ThemeProvider>
    </div>
  );
}

export default Locations;

// AIzaSyA-3LxhatYSsdlelNh_HOJMzZdNllspA2U
